<template>
  <div>
    <b-tabs
      active-nav-item-class="text-success"
      v-model="tabIndex"
    >
      <b-tab
        v-bind:title="
          $store.state.localization.data.mainPage.azk.fuelDepos.pageLabel
        "
      >
        <ListFuelDeposPage
          v-bind:fuelTanks="fuelTanks"
          v-bind:fuelDepos="fuelDepos"
          v-bind:fuelDeposData="fuelDeposData"
          v-bind:globalSettings="globalSettings"
          v-on:itemUpdatedEvent="itemUpdatedEvent"
        ></ListFuelDeposPage>
      </b-tab>
      <b-tab
        v-bind:title="
          $store.state.localization.data.mainPage.azk.fuelTanks.pageLabel
        "
      >
        <ListFuelTanksPage
          v-bind:users="users"
          v-bind:fuelTanks="fuelTanks"
          v-bind:fuelDepos="fuelDepos"
          v-on:itemUpdatedEvent="itemUpdatedEvent"
        ></ListFuelTanksPage>
      </b-tab>
      <b-tab
        v-bind:title="
          $store.state.localization.data.mainPage.azk.trks.pageLabel
        "
      >
        <ListTrksPage
          v-bind:users="users"
          v-bind:trks="trks"
          v-bind:fuelDepos="fuelDepos"
          v-on:itemUpdatedEvent="itemUpdatedEvent"
        ></ListTrksPage>
      </b-tab>
      <b-tab
        v-bind:title="
          $store.state.localization.data.mainPage.azk.guns.pageLabel
        "
      >
        <ListGunsPage
          v-bind:users="users"
          v-bind:trks="trks"
          v-bind:fuelDepos="fuelDepos"
          v-on:itemUpdatedEvent="itemUpdatedEvent"
        ></ListGunsPage>
      </b-tab>
      <b-tab
        v-bind:title="
          $store.state.localization.data.mainPage.azk.users.pageLabel
        "
      >
        <ListUsersPage
          v-bind:users="users"
          v-bind:fuelDepos="fuelDepos"
          v-on:itemUpdatedEvent="itemUpdatedEvent"
        ></ListUsersPage>
      </b-tab>
      <b-tab
        v-bind:title="
          $store.state.localization.data.mainPage.azk.globalSettings.pageLabel
        "
      >
        <ListGlobalSettingsPage
          v-bind:users="users"
          v-bind:globalSettings="globalSettings"
          v-bind:fuelDepos="fuelDepos"
          v-on:itemUpdatedEvent="itemUpdatedEvent"
        ></ListGlobalSettingsPage>
      </b-tab>
      <b-tab
        v-bind:title="
          $store.state.localization.data.mainPage.azk.vehicles.pageLabel
        "
      >
        <ListVehiclesPage
          v-bind:users="users"
          v-bind:fuelTanks="fuelTanks"
          v-bind:vehicles="vehicles"
          v-bind:suppliers="suppliers"
          v-bind:fuelDepos="fuelDepos"
          v-bind:globalDriverCompanies="globalDriverCompanies"
          v-on:itemUpdatedEvent="itemUpdatedEvent"
        ></ListVehiclesPage>
      </b-tab>
      <b-tab
        v-bind:title="
          $store.state.localization.data.mainPage.azk.suppliers.pageLabel
        "
      >
        <ListSuppliersPage
          v-bind:users="users"
          v-bind:suppliers="suppliers"
          v-bind:fuelDepos="fuelDepos"
          v-on:itemUpdatedEvent="itemUpdatedEvent"
        ></ListSuppliersPage>
      </b-tab>
      <b-tab
        v-bind:title="
          $store.state.localization.data.mainPage.azk.drivers.pageLabel
        "
      >
        <ListDriversPage
          v-bind:users="users"
          v-bind:drivers="drivers"
          v-bind:driverCompanies="driverCompanies"
          v-bind:technicalDevices="technicalDevices"
          v-bind:fuelDepos="fuelDepos"
          v-bind:fuelTanks="fuelTanks"
          v-bind:globalDriverCompanies="globalDriverCompanies"
          v-on:itemUpdatedEvent="itemUpdatedEvent"
        ></ListDriversPage>
      </b-tab>
      <b-tab
        v-bind:title="
          $store.state.localization.data.mainPage.azk.driverCompanies.pageLabel
        "
      >
        <ListDriverCompaniesPage
          v-bind:users="users"
          v-bind:driverCompanies="driverCompanies"
          v-bind:fuelDepos="fuelDepos"
          v-on:itemUpdatedEvent="itemUpdatedEvent"
        ></ListDriverCompaniesPage>
      </b-tab>
      <b-tab
        v-bind:title="
          $store.state.localization.data.mainPage.azk.technicalDevices.pageLabel
        "
      >
        <ListTechnicalDevicesPage
          v-bind:users="users"
          v-bind:technicalDevices="technicalDevices"
          v-bind:fuelDepos="fuelDepos"
          v-on:itemUpdatedEvent="itemUpdatedEvent"
        ></ListTechnicalDevicesPage>
      </b-tab>
      <b-tab
        v-bind:title="
          $store.state.localization.data.mainPage.azk.limits.pageLabel
        "
      >
        <ListLimitsPage
          v-bind:users="users"
          v-bind:limits="limits"
          v-bind:drivers="drivers"
          v-bind:fuelDepos="fuelDepos"
        ></ListLimitsPage>
      </b-tab>
      <b-tab
        v-bind:title="
          $store.state.localization.data.mainPage.azk.dutsNaviTrack2TCPServer.pageLabel
        "
      >
        <ListDutsNaviTrack2TcpServerPage
          v-bind:users="users"
          v-bind:dutsNaviTrack2TCPServer="dutsNaviTrack2TCPServer"
          v-bind:fuelTanks="fuelTanks"
          v-bind:fuelDepos="fuelDepos"
        ></ListDutsNaviTrack2TcpServerPage>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { roleService, azkService } from "../../services";
import ListUsersPage from "./Users/ListUsers/ListUsersPage.vue";
import ListGlobalSettingsPage from "./GlobalSettings/ListGlobalSettings/ListGlobalSettingsPage.vue";
import ListFuelTanksPage from "./FuelTanks/ListFuelTanks/ListFuelTanksPage.vue";
import ListTrksPage from "./Trks/ListTrks/ListTrksPage.vue";
import ListGunsPage from "./Guns/ListGuns/ListGunsPage.vue";
import ListFuelDeposPage from "./FuelDepos/ListFuelDepos/ListFuelDeposPage.vue";
import ListVehiclesPage from "./Vehicles/ListVehicles/ListVehiclesPage.vue";
import ListSuppliersPage from "./Suppliers/ListSuppliers/ListSuppliersPage.vue";
import ListDriversPage from "./Drivers/ListDrivers/ListDriversPage.vue";
import ListDriverCompaniesPage from "./DriverCompanies/ListDriverCompanies/ListDriverCompaniesPage.vue";
import ListTechnicalDevicesPage from "./TechnicalDevices/ListTechnicalDevices/ListTechnicalDevicesPage.vue";
import ListLimitsPage from "./Limits/ListLimits/ListLimitsPage.vue";
import ListDutsNaviTrack2TcpServerPage from "./DutsNaviTrack2TcpServer/ListDutsNaviTrack2TcpServer/ListDutsNaviTrack2TcpServerPage.vue";

export default {
  name: "MainPage",
  props: {
    fuelDepos: Array,
  },
  components: {
    ListUsersPage,
    ListGlobalSettingsPage,
    ListFuelTanksPage,
    ListTrksPage,
    ListGunsPage,
    ListFuelDeposPage,
    ListVehiclesPage,
    ListSuppliersPage,
    ListDriversPage,
    ListDriverCompaniesPage,
    ListTechnicalDevicesPage,
    ListLimitsPage,
    ListDutsNaviTrack2TcpServerPage
  },
  data() {
    return {
      tabIndex: 0,
      users: [],
      globalSettings: [],
      fuelTanks: [],
      trks: [],
      drivers: [],
      vehicles: [],
      suppliers: [],
      driverCompanies: [],
      fuelDeposData: []
    };
  },
  async created() {
    if (this.$store.state.authentication.roles.indexOf(roleService.AZK_GET_DATA) != -1) {
      const entitiesResponse = await azkService.getEntities();
  
      if (entitiesResponse.isSuccess) {
        this.users = entitiesResponse.data.users;
        this.globalSettings = entitiesResponse.data.globalSettings;
        this.fuelTanks = entitiesResponse.data.fuelTanks;
        this.trks = entitiesResponse.data.trks;
        this.drivers = entitiesResponse.data.drivers;
        this.vehicles = entitiesResponse.data.vehicles;
        this.suppliers = entitiesResponse.data.suppliers;
        this.driverCompanies = entitiesResponse.data.driverCompanies;
        this.technicalDevices = entitiesResponse.data.technicalDevices;
        this.fuelDeposData = entitiesResponse.data.fuelDepos;
        this.globalDriverCompanies = entitiesResponse.data.globalDriverCompanies;
        this.limits = entitiesResponse.data.limits;
        this.dutsNaviTrack2TCPServer = entitiesResponse.data.dutsNaviTrack2TCPServer;
      }
    }
  },
  methods: {
    async itemUpdatedEvent() {
      const entitiesResponse = await azkService.getEntities();
      
      if (entitiesResponse.isSuccess) {
        this.users = entitiesResponse.data.users;
        this.globalSettings = entitiesResponse.data.globalSettings;
        this.fuelTanks = entitiesResponse.data.fuelTanks;
        this.trks = entitiesResponse.data.trks;
        this.drivers = entitiesResponse.data.drivers;
        this.vehicles = entitiesResponse.data.vehicles;
        this.suppliers = entitiesResponse.data.suppliers;
        this.driverCompanies = entitiesResponse.data.driverCompanies;
        this.technicalDevices = entitiesResponse.data.technicalDevices;
        this.fuelDeposData = entitiesResponse.data.fuelDepos;
        this.limits = entitiesResponse.data.limits;
        this.dutsNaviTrack2TCPServer = entitiesResponse.data.dutsNaviTrack2TCPServer;
      }
    },
  },
};
</script>

